import { Pill, IconCheckLine } from '@smarterservices/smarter-ui';
import { useExamSessionStore } from '../../stores/StoreContext';

const ReviewStatus = () => {
    const reviewRequired = useExamSessionStore((state) => state.sessionData?.reviewRequired);
    const reviewCompletedDate = useExamSessionStore((state) => state.sessionData?.reviewCompletedDate);
    const reviewByDate = useExamSessionStore((state) => state.sessionData?.reviewedBy);

    if (!reviewRequired && !reviewByDate && !reviewCompletedDate) {
        return null;
    }

    if (reviewRequired && !reviewCompletedDate) {
        return (
            <Pill margin="small" size="small" color="danger" renderIcon={<IconCheckLine />} variant="danger">
                Audit Required
            </Pill>
        );
    }

    if (reviewCompletedDate) {
        return (
            <Pill margin="small" size="small" color="success" renderIcon={<IconCheckLine />} variant="success">
                Audited
            </Pill>
        );
    }
}

export default ReviewStatus;
